import React from 'react';
import { AlertSuccess, AlertError } from 'components/layout/alerts/';

export default function SettingsSection({ title, description, children, status, error, onAlertClose }) {
  return (
    <div>
      <h2 className="text-base font-semibold leading-7 text-white">{title}</h2>
      <p className="mt-1 text-sm leading-6 text-gray-400">
        {description}
      </p>
      <dl className="mt-6 divide-y divide-white/10 border-t border-white/10 text-sm leading-6">
        {status && (
          <AlertSuccess autoHideDuration={3000} onClose={onAlertClose}>
            {status}
          </AlertSuccess>
        )}
        {error &&  (
          <AlertError autoHideDuration={3000} onClose={onAlertClose}>
            {typeof error === 'string' ? error : error.message || 'An error occurred'}
          </AlertError>
        )}
        {children}
      </dl>
    </div>
  );
}
